GatorSurvey.app.service("loaderService", LoaderService);
function LoaderService() {
    var self = this;
    var loaderTool = null;

    self.registerObserver = function(loader) {
        loaderTool = loader;
    };

    self.setLoaderState = function(state) {
        loaderTool(state);
    };
}
